import axios from "axios";

const state = {
	
	sosInfo: null,

};

const actions = {

    async loadSosInfo(context, code){
		return axios.get("/api/1/dashboard").then(function(response){
			

			context.commit("setSosInfo",response.data);

		})
	},
	
}

const mutations = {
	setSosInfo(state,data){
		state.sosInfo = data;
	},
}

const getters = {
	sosInfo(state){
		return state.sosInfo;
	},
};
  

export default {
    state,
    actions,
    mutations,
    getters
};